import { NotificationInterface, NotificationData } from "./notifications.interface";
import { NotificationsContextEnum } from "./notifications.enum";

export class Notification implements NotificationInterface {
    public id: string;
    public created: Date;
    public context: NotificationsContextEnum;
    public data: NotificationData;
    public visible: boolean = true;

    constructor(context: NotificationsContextEnum, data: NotificationData) {
        this.id = Math.random().toString(36).replace('0.', '');
        this.context = context;
        this.data = data;
        this.created = new Date();
    }
}
  